<template>
  <component v-for="m of modules" :is="m.ViewComponent" :key="m.key" v-bind="allProps(m)" />
</template>

<script>
import { ModuleManager } from "@module-system";

export default {
  name: "ListConatiner",
  props: {
    sectionType: {
      type: String,
      required: true,
    },
    rtcId: {
      type: String,
      required: false,
    },

    // Adding this will prevent a vue.js warning
    modelValue: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    modules() {
      const modules = ModuleManager.getViewModules(this.sectionType, this.rtcId);
      return modules.value;
    },
  },
  methods: {
    allProps(module) {
      let allProps = { ...this.$props };
      // filter out modelValue from props if it is not defined
      if (!allProps.modelValue) {
        delete allProps.modelValue;
      }

      if(allProps.sectionType) {
        delete allProps.sectionType;
      }

      return { ...allProps, ...module.props, ...this.$attrs, ...module.attrs, ...module.listeners, ...module.slots };
    },
  },
  created() {
    if (this.modules.length == 0) {
      console.info(`ListContainer: ${this.sectionType} => no modules found`);
    } else {
      const names = this.modules.map((m) => m.name).join(", ");
      console.log(`ListContainer:  ${this.sectionType} => loaded ${this.modules.length} modules (${names})`);
    }
  },
};
</script>

<style scoped>
.list-container {
  z-index: 9;
  flex-direction: column;
}
.list-container * {
  margin-top: 2vh;
}
</style>
